import { z } from 'zod';
export const BoardModeSchema = z.enum(['DRAFT', 'ASSIGNMENT']);
export const BoardStatusSchema = z.enum([
    'NEW',
    'VIEWED',
    'WORKING',
    'FINISHED',
    'REVIEWED',
]);
// PATCH /api/boards/:id/assignment — редактирует репетитор.
// Все поля опциональные: репетитор может менять по одному.
// status в запросе ограничен — авто-переходы (VIEWED/WORKING/FINISHED)
// идут через /mark, вручную допустим только REVIEWED + опционально
// NEW (сброс после комментария).
export const UpdateAssignmentRequestSchema = z.object({
    mode: BoardModeSchema.optional(),
    dueAt: z.string().datetime().nullable().optional(),
    hintText: z.string().max(10_000).nullable().optional(),
    hintVideoUrl: z.string().url().max(500).nullable().optional(),
    tutorComment: z.string().max(5_000).nullable().optional(),
    status: z.enum(['REVIEWED', 'NEW']).optional(),
});
// Heartbeat от ученика: сколько секунд активной работы прошло с предыдущего
// тика. Ограничение 1..300 защищает от накрутки и слишком больших дельт.
export const TimeTickRequestSchema = z.object({
    delta: z.number().int().min(1).max(300),
});
// POST /api/boards/:id/mark — от ученика, авто-переходы статусов.
// Репетитор для REVIEWED использует /assignment PATCH.
export const MarkRequestSchema = z.object({
    mark: z.enum(['viewed', 'working', 'finished']),
});
//# sourceMappingURL=assignments.js.map